import { z } from 'zod';
import { brandGradientSchema, hexColorSchema } from '@glomopay/utils';

import { isHttpsUrl } from './validators';

export const tenantBrandingSchema = z.object({
  primaryColor: hexColorSchema,
  brandGradient: brandGradientSchema.nullish(),
  fontFamily: z.string().min(1).nullable(),
  fontsCssUrl: z.string().refine(isHttpsUrl, 'Must be an https:// URL').nullable(),
  logoUrl: z.string().refine(isHttpsUrl, 'Must be an https:// URL').nullable(),
  showPoweredBy: z.boolean(),
});
